// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2jmek","header":"ClearentDisclaimer_header__2HnBN","inner":"ClearentDisclaimer_inner__1aSb9"};